<template>
  <AgCharts :options="props.options" class="gu-chart" />
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { AgCharts } from 'ag-charts-vue3'

import { setLicenseKey } from '@gu-chart/utils/chartsConfig'

onBeforeMount(() => {
  setLicenseKey()
})

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
    description: 'Chart settings and data',
  },
})
</script>
